/**
 * @param {import('./chatbotWebSocketSession').ChatbotWebSocketSession} session
 * @param {{
 *   message: string,
 *   conversationId?: string,
 *   settings: object,
 *   onTextDelta?: (chunk: string) => void,
 *   onConversationId?: (id: string) => void,
 * }} params
 * @returns {Promise<{ assistantText: string, conversationId: string }>}
 */
export function sendChatbotWsTurn(session, params) {
  if (!session || typeof session.sendTurn !== 'function') {
    return Promise.reject(
      new Error('Chatbot WebSocket session is required for sendChatbotWsTurn.'),
    );
  }
  return session.sendTurn(params);
}
